import types from '../store/mutation-types'

export default {
  /**
   * 获取配置信息
   */
  getConfig (that, channel) {
    const productCodes = {
      'guohua-qingzheng': [ // 国华轻症升级
        '150459718262681719',
        '150514806330000319'
      ],
      'aeonlife-zhongji': [ // 百年人寿重疾 - 轻症豁免版
        '150476691002746473',
        '150537492578996275',
        '150572818874302097', // 仅用于秒杀，测试
        '150572806361984311' // 仅用于秒杀，正式
      ],
      'aeonlife-zhongji-zhongji': [ // 百年人寿重疾 - 重疾版
        '150570517523511386',
        '150546537968917914'
      ],
      'hqzj': [ // 横琴重疾
        '150634119420883220', // 测试
        '150631164164706555' // 正式
      ],
      'xiaoqinbao': [ // 孝亲宝
        '150831059068987214', // 测试
        '150840325766681140'
      ],
      'nianjinxian': [ // 年金险
        '151013300258317638', // 测试
        '151072428587363110'
      ]
    }
    const hooliganFolders = ['aeonlife-zhongji']
    const productCode = that.$store.state.app.productCode
    let folder = ''
    for (let key in productCodes) {
      if (productCodes[key].indexOf(productCode) !== -1) {
        folder = key
        break
      }
    }
    return new Promise((resolve, reject) => {
      let suffix = ''
      if (channel.h5) { // 渠道
        suffix += '-h5'
        console.log(folder + '  ' + channel.innerCode)
        // 商户是否有自己的配置
        if ((channel.innerCode === '148118493776884477' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '150872284409485984' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '150969707413088389' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '151029685664879251' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '149795387493052064' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '151503907511146703' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '151600165888036465' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '149309971802225199' && folder === 'aeonlife-zhongji') ||
        (channel.innerCode === '148118493776884477' && folder === 'xiaoqinbao') ||
        (channel.innerCode === '151029685664879251' && folder === 'xiaoqinbao') ||
        (channel.innerCode === '149795387493052064' && folder === 'xiaoqinbao') ||
        (channel.innerCode === '151144054861855874' && folder === 'aeonlife-zhongji') || // 保险岛B端平台
        (channel.innerCode === '151144054861855874' && folder === 'hqzj') ||
        (channel.innerCode === '151144054861855874' && folder === 'xiaoqinbao') ||
        (channel.innerCode === '151144054861855874' && folder === 'nianjinxian') ||
        (channel.innerCode === '151693523265305266' && folder === 'nianjinxian') ||
        (channel.innerCode === '148118493776884477' && folder === 'nianjinxian') ||
        (channel.innerCode === '152247173079388684' && folder === 'hqzj') ||
        (channel.innerCode === '151693523265305266' && folder === 'hqzj')) {
          suffix += '-' + channel.innerCode
        }
      } else { // 合伙人和悟空保
        // 判断这个产品是否悟空保和合伙人加载不同的配置文件
        if (hooliganFolders.indexOf(folder) !== -1) { // 是流氓产品
          if (['149673178664394306', '148198068433580000'].indexOf(that.$store.state.app.innerCode) === -1) { // 合伙人
            suffix += '-partner'
          }
        }
      }
      console.log(folder)
      that.$http.get(window.location.protocol + '//' + window.location.host + window.location.pathname + 'static/mock/' + folder + '/config' + suffix + '.json').then(response => {
        that.$store.commit(types.UPDATE_CONFIG, response.data)
        // 插入主题样式
        const style = window.document.createElement('style')
        style.innerHTML = `
          html a,
          #html .theme-color,
          #html .weui-icon-success,
          #html .vux-datetime-confirm,
          #html .vux-popup-picker-header-menu-right,
          #html .weui-dialog__btn_primary,
          #html .vux-tab .vux-tab-item.vux-tab-selected {
            color: ${that.$store.state.config.themeColor};
          }
          #html .vux-number-selector svg {
            fill: ${that.$store.state.config.themeColor};
          }
          #html .nav .active {
            border-bottom-color: ${that.$store.state.config.themeColor};
          }
          #html .border-theme-color,
          #html .weui-switch:checked {
            border-color: ${that.$store.state.config.themeColor};
          }
          #html .theme-bg-color,
          #html .weui-btn_primary,
          #html .vux-slider .vux-indicator a .vux-icon-dot.active,
          #html .weui-switch:checked,
          #html .vux-tab-ink-bar {
            background-color: ${that.$store.state.config.themeColor};
          }
          #html .weui-btn_disabled.weui-btn_primary {
            background-color: ${that.$store.state.config.themeDisabledColor};
          }
          #html .weui-btn_primary:not(.weui-btn_disabled):active {
            background-color: ${that.$store.state.config.themeActiveColor};
          }
          #html .weui-dialog__btn_default {
            color: #979797;
          }
        `
        window.document.querySelector('head').appendChild(style)
        resolve(true)
      })
    })
  },
  /**
   * 获取用户名
   */
  getUserName (that) {
    return new Promise((resolve, reject) => {
      that.$http.get('/api/hqdqx/getAgentUserInfo/' + that.$store.state.app.innerCode).then(response => {
        resolve((response.data.authorityStatus === 3 && response.data.name) || response.data.nickname || response.data.phone)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js